import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { MessageService } from './message.service';

@Injectable({
  providedIn: 'root'
})
export class BaseService {

  http: HttpClient;
  messageService: MessageService;

  // za hitrejše testiranje, mimo WG
  private wgMode: boolean = false;

  constructor(http: HttpClient, messageService: MessageService) {
      this.http = http;
      this.messageService = messageService;      
  }

  dataGET<T>(url:string) {
      var cookie = this.getToken();
      var o = { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.getToken(), 'Content-Type': 'application/json' }) };
      return this.http.get<T>(url, o)
  }

  dataPOST<T>(url:string, data:string) 
  {
      var cookie = this.getToken();
      var o = { headers: new HttpHeaders({ 'Authorization': 'Bearer ' + this.getToken(), 'Content-Type': 'application/json' }) };
      return this.http.post<T>(url, data, o);
  }

  wsUrl(path:string)
  {
       return this.getApiUrl() +path;
  }


  private getToken():string
  {
      var token = this.getCookie("_galis_access_token");
      return token;
  }

  public setToken(token:string){

      this.setCookie("_galis_access_token", token, 1);
  }

  public setApiUrl(token:string){

      this.setCookie("_galis_access_apiurl", token, 1);
  }

  private getApiUrl():string
  {
      return environment.wgProfileHost + "/api/platform";
      //var token = this.getCookie("_galis_access_apiurl");
      //return token;
  }

  private getCookie(name: string) {
      let localStorageValue = localStorage.getItem(name);
    let ca: Array<string> = localStorageValue.split(';');
      let caLen: number = ca.length;
      let cookieName = `${name}=`;
      let c: string;

      for (let i: number = 0; i < caLen; i += 1) {
          c = ca[i].replace(/^\s+/g, '');
          if (c.indexOf(cookieName) == 0) {
              return c.substring(cookieName.length, c.length);
          }
      }
      return '';
  }

  private setCookie(name: string, value: string, expireDays: number, path: string = '') {
      let d:Date = new Date();
      d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
      let expires:string = `expires=${d.toUTCString()}`;
      let cpath: string = path ? `; path=${path}` : '';
      let cookieValue = `${name}=${value}; ${expires}${cpath}`;
      localStorage.setItem(name, cookieValue);

    // this didnt work so we changes to localstorage 
    //document.cookie = test;    
  }
}
